import React from "react";
import { BrowserRouter, Route } from "react-router-dom";
// import New from "./pages/testing";
import Caller from "./book/caller";
import Home from "./book/home";
import Testing from "./pages/oldtesting";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";

const outerTheme = createMuiTheme({
  palette: {
    primary: {
      main: "#1ebea5",
      contrastText: "#FFFFFF",
    },
  },
});

function App() {
  return (
    <div>
      <ThemeProvider theme={outerTheme}>
        <BrowserRouter>
          <Route exact path="/" component={Caller} />
          <Route path="/r/:init/:id" component={Home} />
          <Route path="/testing/:id" component={Testing} />
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
